import React from "react";
import {Helmet} from "react-helmet";
import 'firebase/auth';
import RegisterView from '../components/RegisterView';
import withRegisterForm from "../helpers/withRegisterForm";

/**
 * View of link
 * @type {function({next: *, [p: string]: *}): *}
 */
export const Register = withRegisterForm((props)=> (<>
	<Helmet htmlAttributes={{class: 'view-anonymous web user-register'}}>
		<title>{`user:register`.t()}</title>
	</Helmet>
	<RegisterView {...props} />
</>))

export default Register;
